import React, { useState, useEffect } from "react";
import { hot } from "react-hot-loader";
import useStarfishAPI from "hooks/useStarfishAPI";
import Form from "./Form";
import { NotificationCenter } from 'utils/types';
import Toast from "../common/Toast";

/*
 * End users can request a report to show how many hours their staff and faculty have available to  meet
 * with students (student contact hours) for a specific date range and service.   Users can choose a term
 * to make it easy for them to set dates.
 */
const App = (props) => {

  const [terms, setTerms] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceResponse, callServiceAPI] = useStarfishAPI();
  const [termResponse, callTermAPI] = useStarfishAPI();
  const [toastMessage, setToastMessage] = useState(null);
  const [toastTimeOut, setToastTimeout] = useState(5000);

  useEffect(() => {
    callTermAPI(`../admin/getTerms.html`);
  }, []);

  useEffect(() => {
    if (termResponse.success) {
      setTerms(termResponse.data.terms);
    }
  }, [termResponse]);

  useEffect(() => {
    if (termResponse.error) setToastMessage(termResponse.error);
    else if (serviceResponse.error) setToastMessage(serviceResponse.error);
  }, [termResponse, serviceResponse]);

  useEffect(() => {
    callServiceAPI(`../admin/getServiceList.html`);
  }, []);

  useEffect(() => {
    if (serviceResponse.data.sucess) {
      setServices(serviceResponse.data.results);
    }
  }, [serviceResponse]);

  return (
    <React.Fragment>
      <Form
        terms={terms}
        services={services}
        notificationCenter={props.notificationCenter}
        setToastMessage={setToastMessage}
        toastMessage={toastMessage}
        setToastTimeout={setToastTimeout}
        toastTimeout={toastTimeOut}
      />

      {toastMessage &&
      <Toast
        message={toastMessage}
        timeout={toastTimeOut}
        onTimeout={() => setToastMessage(null)}
      />
      }
    </React.Fragment>
  )
};

App.propTypes = {
  notificationCenter: NotificationCenter.isRequired
};

export default hot(module)(App);
